import { useNavigate } from "react-router-dom";
import BoothMark from "./BoothMark";
import "./FinalCta.css";

function FinalCta() {
  const navigate = useNavigate();

  return (
    <section aria-label="Get started" className="booth-shell booth-final">
      <p className="booth-final-eyebrow">Step inside</p>
      <BoothMark as="p" className="booth-final-mark" />
      <div className="booth-final-action">
        <button type="button" className="booth-btn booth-btn--primary" onClick={() => navigate("/auth")}>
          Add your league <span aria-hidden="true">→</span>
        </button>
      </div>
    </section>
  );
}

export default FinalCta;
